import PIXI from 'pixi.js/src';
import config from './../config/config';
import data from './../data/data';
import GameStore from './../stores/GameStore';
import frameAnimationHelper from './../helpers/frame-animation';
import audioHelper from './../helpers/audio';
import renderHelper from './../helpers/render';
import router from './../router/router';

const startView = {
  startButtonWidth: 150,
  startButtonHeight: 40,
  landingGraphicsWidth: 300,
  landingGraphicsHeight: 451,
  initialized: false,


  /**
   * Sets up the view
   * @returns {undefined} undefined
   */
  init() {
    const state = GameStore.getState();

    this.initialized = false;

    if (state.mainAssetsLoaded) {
      this.doIntro();
    } else {
      router.navigate('preloader');
    }
  },


  /**
   * Does the intro animation
   * @returns {undefined} undefined
   */
  doIntro() {
    const creditsString = '©2016 BLEACHER REPORT\nART BY NICHOLAS LITTLE' +
      '\nPROGRAMMING BY MIKE FEY';

    this.initialized = true;
    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);

    frameAnimationHelper.create(
      this.graphicsContainer,
      data.landingPaths,
      10,
      false,
      this.landingGraphicsWidth,
      this.landingGraphicsHeight);

    this.startButton = new PIXI.Text('START >',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
      }
    );

    this.startButton.resolution = 2;
    this.startButton.interactive = true;
    renderHelper.stage.addChild(this.startButton);

    this.creditsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.creditsContainer);

    this.creditsText = new PIXI.Text(creditsString,
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
        align: 'center',
      }
    );

    this.creditsText.resolution = 2;
    this.creditsContainer.addChild(this.creditsText);

    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);
    document.addEventListener('touchend', this.onStartButtonClick);
    this.positionGraphics();
  },


  /**
   * Click handler for the start button
   * @returns {undefined} undefined
   */
  onStartButtonClick() {
    const state = GameStore.getState();

    audioHelper.playSound('theme', 0.7, true);
    // audioHelper.playSound('allsounds', 0, false, 0.8, 0.8);

    if (!state.instructionsViewed) {
      router.navigate('instructions', { standalone: true });
    } else {
      router.navigate('game');
    }
  },


  /**
   * Click handler for the start button
   * @returns {undefined} undefined
   */
  onInstructionsButtonClick() {
    router.navigate('instructions');
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.graphicsContainer.x =
      Math.round((window.innerWidth / 2) - (this.landingGraphicsWidth / 2));
    this.graphicsContainer.y =
      Math.round((window.innerHeight / 2) - (this.landingGraphicsHeight / 2));

    this.startButton.x = Math.round((window.innerWidth / 2) -
      (this.startButton.width / 2));
    this.startButton.y = this.graphicsContainer.y + 250;

    this.creditsContainer.x = Math.round((window.innerWidth / 2) -
      (this.creditsText.width / 2));
    this.creditsContainer.y = window.innerHeight -
      (this.creditsText.height + 20);
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    if (this.initialized) {
      window.removeEventListener('resize', this.resizeListener);
      window.removeEventListener('orientationchange', this.resizeListener);
      document.removeEventListener('touchend', this.onStartButtonClick);
      renderHelper.stage.removeChild(this.startButton);
      renderHelper.stage.removeChild(this.graphicsContainer);
      renderHelper.stage.removeChild(this.creditsContainer);
      frameAnimationHelper.destroyAllAnimations();
    }
  },
};

export default startView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/start.js
 **/